import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowRight } from "lucide-react";
import { homeMeta } from "../lib/seo";

export default function HomePage() {
  const meta = homeMeta();
  return (
    <div
      className="mx-auto w-full max-w-[1400px] px-5 py-16 md:px-gutter md:py-24"
      data-testid="home-page"
    >
      <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="robots" content={meta.robots} />
        <link rel="canonical" href={meta.canonical} />
        <meta property="og:site_name" content="CardCapture" />
        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.description} />
        <meta property="og:url" content={meta.canonical} />
        <meta property="og:type" content={meta.ogType} />
        <meta property="og:image" content={meta.ogImage} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={meta.title} />
        <meta name="twitter:description" content={meta.description} />
        <meta name="twitter:image" content={meta.ogImage} />
      </Helmet>
      <div className="max-w-[720px]">
        <div className="mb-4 text-eyebrow uppercase text-indigo-text">
          Visual reference library
        </div>
        <h1 className="text-title-page text-ink-text">
          See what a card actually looks like — as shown by the collector
          community.
        </h1>
        <p className="mt-6 max-w-[62ch] text-body text-ink-muted">
          CardCapture is a reference site for what trading cards look like in
          real life: holo patterns, surface texture, centering, foil, print
          characteristics. Every card has its own page. Approved collector
          submissions are ranked using a Wilson score lower confidence bound,
          not raw upvotes.
        </p>
      </div>

      <div className="mt-16 grid grid-cols-1 gap-4 md:grid-cols-2">
        <Link
          to="/pokemon"
          data-testid="home-tcg-pokemon"
          className="animate-rise group flex items-center gap-6 rounded-card border border-ink-chip bg-ink-surface p-6 transition-colors duration-cc ease-cc-ease hover:border-ink-muted"
        >
          <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-card border border-ink-chip bg-ink-raised text-title-section text-ink-text">
            P
          </div>
          <div className="flex-1">
            <div className="text-eyebrow uppercase text-ink-muted">
              Trading Card Game
            </div>
            <div className="mt-1 text-title-section text-ink-text">Pokémon</div>
            <div className="mt-1 text-meta text-ink-muted">
              English catalog · sourced from TCGdex
            </div>
          </div>
          <ArrowRight
            size={18}
            className="text-ink-muted transition-colors duration-cc ease-cc-ease group-hover:text-ink-text"
          />
        </Link>

        <div className="animate-rise flex flex-col justify-between rounded-card border border-ink-chip bg-ink-surface p-6 opacity-70">
          <div>
            <div className="text-eyebrow uppercase text-ink-muted">More TCGs</div>
            <div className="mt-1 text-title-section text-ink-text">
              Coming after V1
            </div>
          </div>
          <p className="mt-4 text-body text-ink-muted">
            V1 covers English Pokémon. The data model already supports
            additional games and languages; they'll unlock in future releases.
          </p>
        </div>
      </div>
    </div>
  );
}
